import { useState, useEffect } from "react";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import "./TransactionEntry.css";
import callIcon from "../../../Images/callIcon.png"
import videoIcon from "../../../Images/videoIcon.png"
import cancelCallIcon from "../../../Images/cancelCallIcon.png"
import cancelVideoIcon from "../../../Images/cancelVideoIcon.png"

const TransactionEntry = ({ rawData }) => {
  const [additionalInput, setAdditionalInput] = useState({});
  // Destructuring with renaming some properties
  const {
    ClientName, clientName,
    ClientPIN: clientPin,
    Id: userId,
    Input1: input1,
    Input2: input2,
    Input3: input3,
    Input4: input4,
    Input5: input5,
    Input6: input6,
    Input7: input7,
    Input8: input8,
    LanguageService: languageService,
    ProductName: productName,
    ProviderId: providerId,
    ProviderName: providerName,
    ReportIssueUrl: reportIssueUrl,
    RequestTime: requestTime,
    ServiceMinutes: serviceMinutes,
    ServiceSeconds: serviceSeconds,
    TransactionId: transactionId,
    TransactionRequestStatus: transactionRequestStatus,
    TransactionRequestStatusCodeId: transactionRequestStatusCodeId,
    isVideo,
  } = rawData;

  useEffect(() => {
    // up to 8 inputs,
    /* only if it exists
    {
      input1: "value",
      input2: "value",
      input3: "value",
      input4: "value",
      input5: "value",
      input6: "value",
      input7: "value",
      input8: "value",
    }
    */
    setAdditionalInput({
      // input1: clientName || ClientName,
      // input2: productName,
      input1: input1 === "" ? null : input1,
      input2: input2 === "" ? null : input2,
      input3: input3 === "" ? null : input3,
      input4: input4 === "" ? null : input4,
      input5: input5 === "" ? null : input5,
      input6: input6 === "" ? null : input6,
      input7: input7 === "" ? null : input7,
      input8: input8 === "" ? null : input8,
    });
  }, [])

  const popover = (
    <Popover id={`popover-${transactionId}`} className="no-arrow">
      <Popover.Body>
        {/* Go through each additional input, display key: value */}
        {/* should have a br and hr under, except first and last */}
        {Object.entries(additionalInput).map(([key, value], index) => {
          if (value) {
            if (index === Object.keys(additionalInput).length - 1) {
              return (
                <div key={index}>
                  <strong>{key}:</strong> {value}
                </div>
              );
            }
            return (
              <div key={index}>
                <strong>{key}:</strong> {value}<br />
                <hr />
              </div>
            );
          }
          return null;
        })}
      </Popover.Body>
    </Popover>
  );

  const formattedTime = new Date(requestTime).toLocaleString('en-US', {
    month: 'short', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true
  });

  let statusIcon;
  if (isVideo) {
    if (transactionRequestStatus === "Canceled") {
      statusIcon = cancelVideoIcon;
    } else {
      statusIcon = videoIcon;
    }
  } else {
    if (transactionRequestStatus === "Canceled") {
      statusIcon = cancelCallIcon;
    } else {
      statusIcon = callIcon;
    }
  }

  return (
    <div className="table-entry">
      <img src={statusIcon} alt={transactionRequestStatus ? 'Cancelled' : 'Success'} className={isVideo ? "status-icon" : "call-icon"} />
      <div>{languageService}</div>
      <div>{formattedTime}</div>
      <div>{serviceMinutes} mins</div>
      <div>{transactionId}</div>
      <div>{providerName}</div>
      <div>{providerId}</div>
      {
        (Object.values(additionalInput).some(value => value !== null)) 
        &&
        <OverlayTrigger trigger="click" placement="bottom-end" overlay={popover} rootClose>
        <Button className="elipses no-active-bg">...</Button>
      </OverlayTrigger>
      }
      
    </div>
  );
};

export default TransactionEntry;
